<script>
import { mapState } from 'pinia';
import { alertsStore } from '../../stores/alerts';

export default {
	computed: {
		...mapState(alertsStore, { alerts: 'errors' })
	}
};
</script>

<template>
	<template v-if="alerts.length > 0">
		<p v-for="alert in alerts"
			:key="alert.code"
			v-bind="$attrs"
		>{{ alert.message }}</p>
	</template>
</template>

<style scoped>
</style>
